import { useContext } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { UserContext } from '@namespace/user';
import { useWheelStore } from '../../store';
import { WheelSettings } from '../../types';
import { WheelModal } from '../Modal';

export const ModalWrapper = () => {
  const {
    wheelOfFortune = { enabled: false, settings: [] }
  }: { wheelOfFortune: WheelSettings } = useOtherSettings();
  const { enabled } = wheelOfFortune;

  const { isModalOpened } = useWheelStore();

  const [user] = useContext(UserContext);
  const { role, userInfoLoaded } = user;

  if (!enabled) {
    return null;
  }

  return (
    <>
      {isModalOpened && (
        <WheelModal userRole={role} userInfoLoaded={userInfoLoaded} />
      )}
    </>
  );
};
